'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Severity = require('../constants/Severity');

var _Severity2 = _interopRequireDefault(_Severity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventData = function EventData(alarms) {
  _classCallCheck(this, EventData);

  var aboveNav = [];
  var belowNav = [];

  this.alarms = alarms;
  this.groupedAlarms = alarms.reduce(function (map, alarm) {
    var alarmSeverity = alarm.severity.key;
    map[alarmSeverity] = map[alarmSeverity] || [];

    if (alarm.severity === _Severity2.default.CRITSIT) {
      aboveNav.push(alarm);
    } else {
      belowNav.push(alarm);
    }

    map[alarmSeverity].push(alarm);
    return map;
  }, {});

  this.placement = {
    aboveNav: aboveNav,
    belowNav: belowNav
  };
};

exports.default = EventData;
module.exports = exports['default'];